import { FormWrapper } from '../../../../../theme/default/base'
import { BooleanInput } from '../../form-inputs/Boolean'
import { ColorPicker } from '../../form-inputs/ColorPicker'
import { HtmlInput } from '../../form-inputs/Html'
import { MediaInputPB } from '../../form-inputs/Media'
import { OpacityInput } from '../../form-inputs/Opacity'

export const SmallHeroForm = ({
  description,
  has_cta,
  text_color = 'black',
  title,
  background_image,
  setCurrentComponent
}) => {
  return (
    <FormWrapper>
      <BooleanInput
        value={has_cta}
        name="has_cta"
        label="Call to action"
        setCurrentComponent={setCurrentComponent}
      />
      <HtmlInput
        value={title}
        name="title"
        label="Title"
        height="100px"
        setCurrentComponent={setCurrentComponent}
      />
      <HtmlInput
        value={description}
        name="description"
        label="Description"
        height="400px"
        setCurrentComponent={setCurrentComponent}
      />
      <ColorPicker
        value={text_color}
        label="Text Color"
        name="text_color"
        setCurrentComponent={setCurrentComponent}
      />
      <MediaInputPB
        image={background_image}
        label="Background Image"
        name="background_image"
        setCurrentComponent={setCurrentComponent}
      />
      {background_image && (
        <OpacityInput
          value={background_image?.opacity}
          label="Background Image Opacity"
          name="background_image"
          setCurrentComponent={setCurrentComponent}
        />
      )}
    </FormWrapper>
  )
}
